import SuccessScreen from "./SuccessScreen";

interface ISuccessScreenDesktopProps {
  onRequestOpen: (isOpen: boolean) => void;
}

function SuccessScreenDesktop({
  onRequestOpen,
}: ISuccessScreenDesktopProps): JSX.Element {
  return (
    <div className="md:inset-0 md:h-full fixed top-0 left-0 right-0 z-[101] h-[100%] w-full overflow-y-auto overflow-x-hidden">
      <div className="md:h-auto relative h-[100%] w-full">
        {/* <!-- Modal content --> */}
        <div className="shadow dark:bg-gray-700 relative h-[100%] rounded-lg bg-white">
          {/* <!-- Modal body --> */}
          <SuccessScreen onRequestOpen={onRequestOpen} />
        </div>
      </div>
    </div>
  );
}

export default SuccessScreenDesktop;
